import React from 'react';
import { Link } from 'react-router';
const ConfigurableLink = ({
  link,
  className = undefined,
  activeClassName = undefined,
  isHardLink,
  routeNavigationConfirmation = null,
  children,
  onClick = undefined,
  dataLink = undefined,
  openInNewTab = undefined
}) => isHardLink ? /*#__PURE__*/React.createElement("a", {
  className: className,
  onClick: onClick,
  href: link,
  "data-link": dataLink,
  rel: "noreferrer"
}, children) : /*#__PURE__*/React.createElement(Link, {
  onClick: (...params) => {
    if (routeNavigationConfirmation) {
      routeNavigationConfirmation(link, onClick);
      params[0].preventDefault();
      return;
    }
    onClick && onClick(...params);
  },
  activeClassName: activeClassName,
  className: className,
  to: link,
  "data-link": dataLink
  // @todo. auto generated. fix this error
  // @ts-ignore
  ,
  target: openInNewTab && '_blank',
  rel: openInNewTab ? 'noopener noreferrer' : ''
}, children);
export default ConfigurableLink;